import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"
import { logout } from './userSlice';


export const initialState = {
  dashboard: {
    analytics: {
      locations: 17,
      totalSessions: 220,
      completedSessions: 177,
      activeSessions: 19
    },
    monthWiseSessions: [65, 59, 80, 81, 56, 55, 40, 60, 70, 80, 90, 100],
  },
  error: null,
  loader: false,
  featured: {},
  current_page: 1,
  per_page: PAGELENGTH
}

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: initialState,
  reducers: {
    setDashboardAnalytic: (state, { payload }) => {
      state.dashboard = payload?.data ?? payload;
    },
    setDashboardAnalytics: (state, { payload }) => {
      state.dashboard.analytics = payload;
    },
    setMonthWiseSessions: (state, { payload }) => {
      state.dashboard.monthWiseSessions = payload;
    },
    setDashboardAppointments: (state, { payload }) => {
        state.dashboard.monthWiseSessions = payload?.data;
        state.total = payload?.total;
        state.is_more = payload?.is_more;
        state.last_page = payload?.last_page;
        state.current_page = payload?.current_page;
        state.per_page = payload?.per_page
    },
    removerVendorReports: (state, { payload }) => {
      state.error = payload
    },
    clearAllDashboard: (state, { payload }) => {
        state.loader = payload
    },
    setError: (state, { payload }) => {
        state.error = payload
    },
    setLoader: (state, { payload }) => {
        state.loader = payload
    },
  }
})


export const fetchDashboardAnalytics = (params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {
      
      const result = await Api.fetchClientDashboardAnalytics(params)
      if (result.status >= 200 && result.status < 300) {
          dispatch(setDashboardAnalytics(result.data.data));
          dispatch(setMonthWiseSessions(result.data.data))
    }
    else if (result?.status == 422) {
        dispatch(setError(result.data))
    }
    else if(result?.status == 401){
      dispatch(setError("Unauthorized"))
      dispatch(logout())
    }
  } catch (error) {
    console.log("error", error)
    
  }
  !disableLoader && dispatch(setLoader(false))
}



export const fetchDashboardAppointments = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

      const result = await Api.fetchClientDashboardAppointment(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setDashboardAppointments(result.data.data));
      } else {
        dispatch(setDashboardAppointments(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
    else if(result?.status == 401){
      dispatch(setError("Unauthorized"))
      dispatch(logout())
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader &&  dispatch(setLoader(false))
}



export const { setDashboardAnalytics, clearAllDashboard, setLoader, setError ,setDashboardAppointments, setMonthWiseSessions} = dashboardSlice.actions

export default dashboardSlice.reducer
export const DashboardSelector = state => state.dashboard



